import React from "react";

const SuccessIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.01437 25.3316L6.78374 21.5722L2.54812 20.6441L2.96155 16.2838L0.0915527 13L2.96155 9.71625L2.54812 5.35594L6.78374 4.42782L9.01437 0.668442L13 2.36063L16.9856 0.668442L19.2162 4.42782L23.4519 5.35594L23.0384 9.71625L25.9084 13L23.0384 16.2838L23.4519 20.6441L19.2162 21.5722L16.9856 25.3316L13 23.6394L9.01437 25.3316ZM11.6875 17.0047L18.3172 10.375L17 9.01938L11.6875 14.3319L8.99999 11.6828L7.6828 13L11.6875 17.0047Z"
        fill="#73D09A"
      />
    </svg>
  );
};

export default SuccessIcon;
